import React, { useContext, useEffect, useState } from 'react';
import { talleresApi } from '../api/casosApi';
import UserContext from './user-context';

const TallerFilterContext = React.createContext({
  selectedTaller: null,
  setSelectedTaller: () => {},
  talleres: []
});

const TallerFilterProvider = ({ children }) => {
  const [selectedTaller, setSelectedTaller] = useState(null);
  const [talleres, setTalleres] = useState([]);
  const { user } = useContext(UserContext);

  useEffect(() => {
    if (!user) return;
    talleresApi
      .getAll()
      .then(setTalleres)
      .catch(() => {});
  }, [user]);

  return (
    <TallerFilterContext.Provider
      value={{ selectedTaller, setSelectedTaller, talleres }}
    >
      {children}
    </TallerFilterContext.Provider>
  );
};

export default TallerFilterContext;
export { TallerFilterProvider };
